import React, { Component } from 'react';

class HrCustom extends Component {
  render() {
  let {component}=this.props;

    return (
      <div className={component.widths.parent ? component.widths.parent :  "col-sm-4 col-md-3 col-lg-2"}>
        <hr style={{margin:"5px 0px 5px 0px"}}/>
      </div>
    );
  }
}

export default HrCustom;